export interface AuditScoreState {
    passed: number;
    low: number;
    medium: number;
    high: number;
    score: number;
}

export enum AuditScoreStatus {
    Passed = 'passed',
    Low = 'low',
    High = 'high',
    Medium = 'medium'
}

export class AuditScore implements AuditScoreState {
    static zero = Object.freeze(new AuditScore(0, 0, 0, 0, 0));
    static statuses = ['passed', 'low', 'high', 'medium'] as AuditScoreStatus[];

    constructor(
        public passed: number,
        public low: number,
        public medium: number,
        public high: number,
        public score: number
    ) {}

    static fromState(state: AuditScoreState) {
        return new AuditScore(state.passed, state.low, state.medium, state.high, state.score);
    }

    static statesEqual(a: AuditScoreState, b: AuditScoreState) {
        const existenceEqual = (!a && !b) || (a && b);
        if (!existenceEqual) {
            return false;
        } else if (a && b) {
            for (const k in a) {
                if (a[<keyof AuditScoreState>k] !== b[<keyof AuditScoreState>k]) {
                    return false;
                }
            }
        } else {
            return false;
        }
        return true;
    }
}
